import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';
import { computed } from 'mobx';

export class EmailDocumentTemplateListDataService extends DataService<typeof Model.General.Logic.ViewModels.EmailDocumentTemplateSummary, Model.General.Logic.ViewModels.EmailDocumentTemplateSummary, IEmailDocumentTemplateSummary> {
	protected map(entity: Model.General.Logic.ViewModels.EmailDocumentTemplateSummary): IEmailDocumentTemplateSummary {
		return new EmailDocumentTemplateSummaryModel(entity);
	}

	public static make(context?: ContextService): EmailDocumentTemplateListDataService {
		return new EmailDocumentTemplateListDataService(context, ctx => ctx.EmailDocumentTemplateSummaries);
	}
}

export class EmailDocumentTemplateSummaryModel extends EntityModel<Model.General.Logic.ViewModels.EmailDocumentTemplateSummary, IEmailDocumentTemplateSummary> implements IEmailDocumentTemplateSummary {
	@property<EmailDocumentTemplateSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	
	@property<EmailDocumentTemplateSummaryModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
	public categoryId: number;

	@property<EmailDocumentTemplateSummaryModel>(o => o.entity.categoryDisplayName, (o, value) => o.entity.categoryDisplayName = value)
	public categoryDisplayName: string;


	@property<EmailDocumentTemplateSummaryModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	public name: string;


	@property<EmailDocumentTemplateSummaryModel>(o => o.entity.body, (o, value) => o.entity.body = value)
	public body: string;
	
	@property<EmailDocumentTemplateSummaryModel>(o => o.entity.subject, (o, value) => o.entity.subject = value)
	public subject: string;
	
	@property<EmailDocumentTemplateSummaryModel>(o => o.entity.target, (o, value) => o.entity.target = value)
	public target: number;

	@computed
	public get targetDisplayName() : string {
		switch (this.entity.target) {
			case 0:
				return "Agents";
			case 1:
				return "Clients";
			case 2:
				return "Suppliers"
		}

		return "";
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/list/email-document-template-list.data.ts